import React from 'react';

const SeoBlockAOSmile = ({
	width = '1499',
	height = '494',
	fill = '#14C35A',
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 1499 494"
			className="max-w-full">
			<title>AO Smile</title>
			<g
				id="🇬🇧-Desktop"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd">
				<g
					id="UK_D_L_1200px"
					transform="translate(-203.000000, -3939.000000)"
					fill={fill}
					fillRule="nonzero">
					<g id="Fill-53" transform="translate(0.000000, 3833.000000)">
						<path
							d="M1753.24271,282 L1604.32199,282 C1580.3005,282.029365 1559.71062,299.570052 1555.33177,323.735174 C1508.09262,575.428801 1291.71583,765.517242 1032,765.517242 C772.284172,765.517242 555.827784,575.347366 508.668229,323.735174 C504.261194,299.632517 483.724171,282.142581 459.757602,282.081436 L310.757286,282.081436 C296.276657,282.078285 282.513408,288.530822 273.060926,299.754382 C263.608445,310.977941 259.405047,325.858398 261.548181,340.510677 C316.965633,724.922152 640.814476,1020 1032,1020 C1423.18552,1020 1747.03437,724.922152 1802.45182,340.429242 C1804.59495,325.776963 1800.39156,310.896507 1790.93907,299.672947 C1781.48659,288.449388 1767.72334,282 1753.24271,282 Z"
							id="Path"
							transform="translate(1032.000000, 651.000000) rotate(-15.000000) translate(-1032.000000, -651.000000) "></path>
					</g>
				</g>
			</g>
		</svg>
	);
};

export default SeoBlockAOSmile;
